<script setup lang="ts">import { toRef as _toRef } from 'vue';

import {computed} from 'vue'
import {storeToRefs} from 'pinia'
import ScrollbarComponent from '@toolify/client/src/modules/ui/components/ScrollbarComponent.vue'
import {useDropList} from '@toolify/client/src/modules/ui/composables/useDropList'
import {useWorkspaceTabStore} from '@toolify/client/src/stores/WorkspaceTabStore/useWorkspaceTabStore'
import {IWorkspaceTabDragPayload} from '@toolify/client/src/modules/workspaceTabs/types/IWorkspaceTabDragPayload'
import WorkspaceTabItemComponent from '@toolify/client/src/modules/workspaceTabs/components/WorkspaceTabItemComponent.vue'
import {useThemeVariables} from '@toolify/client/src/modules/theme/composables/useThemeVariables'
import {ThemeVariableType} from '@toolify/client/src/modules/theme/enum/ThemeVariableType'


const workspaceTabStore = useWorkspaceTabStore()
const {tabs} = storeToRefs(workspaceTabStore)
const __$temp_1 = (useThemeVariables()),
  getThemeVariable = _toRef(__$temp_1, 'getThemeVariable');
const tabKeys = computed(() => tabs.value.map(tab => tab.key))

const {listRef} = useDropList<IWorkspaceTabDragPayload>({
  orientation: 'horizontal',
  itemIds: tabKeys,
  accepts: payload => payload.kind === 'workspaceTab',
  onInsert: (payload, index) => {
    workspaceTabStore.reorderTab(payload.tabKey, index)
  },
})
</script>

<template>
  <div v-if="tabs.length" class="workspace-tab-bar">
    <ScrollbarComponent
      class="tab-scroll"
      :gradientColor="getThemeVariable(ThemeVariableType.SurfaceDimColor)"
      :options="{suppressScrollY: true, useBothWheelAxes: true}"
      visibleScrollbarOnlyOnHover
    >
      <div class="tabs" :ref="listRef">
        <WorkspaceTabItemComponent
          v-for="tab in tabs"
          :key="tab.key"
          :tab="tab"
          @activate="workspaceTabStore.activateTab(tab)"
          @close="workspaceTabStore.closeTab(tab.key)"
        />
      </div>
    </ScrollbarComponent>
  </div>
</template>

<style scoped lang="scss">
@use '@toolify/client/src/styles/variables' as variables;

.workspace-tab-bar {
  min-width: 0;
  height: map-get(variables.$sizes, size-lg);
  box-sizing: border-box;
}

.tab-scroll {
  height: 100%;
  min-width: 0;
  --scrollbar-rail-x-height: 0.1875rem;
}

.tabs {
  display: flex;
  align-items: stretch;
  height: map-get(variables.$sizes, size-lg);
  width: max-content;
  gap: map-get(variables.$spacing, space-0-5);
}
</style>
